<img [src]="logoSource" alt="Clearbenchmark Logo" [class]="cssClass" />
